import React from "react"
import PropTypes from "prop-types"
import ResponsiveSearchBox from "@geome/shell-locator-components/lib/components/responsiveSearchBox"
import Pane from "@geome/shell-locator-components/lib/components/pane"
import { translate } from "@geome/intl"
import SettingsButton from "../settings/button"
import BackButton from "@geome/shell-locator-components/lib/components/backButton"

class View extends React.Component {
  static propTypes = {
    isGeolocationAvailable: PropTypes.bool,
    isMobile: PropTypes.bool,
    isSettingsWindowActive: PropTypes.bool,
    selectedLocation: PropTypes.object,
    onGeolocationSelect: PropTypes.func.isRequired,
    unselectLocation: PropTypes.func.isRequired,
    restoreBookmark: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isMobile: false,
  }

  handleBackToResultsButtonClick() {
    this.props.restoreBookmark()
    this.props.unselectLocation()
  }

  renderBackButton() {
    if (!this.props.selectedLocation || this.props.isSettingsWindowActive) return null
    return (
      <BackButton className="u-mt1" onClick={this.handleBackToResultsButtonClick.bind(this)}>
        {translate("info_window.back_to_results")}
      </BackButton>
    )
  }

  getSpacingClasses() {
    return this.props.isMobile
      ? "group-padding-left-small group-padding-y-small"
      : "group-padding-left group-padding-y"
  }

  render() {
    return (
      <Pane innerClassName={this.getSpacingClasses()}>
        <div className="u-flex-row">
          <div className="u-flex-grow-1">
            <ResponsiveSearchBox
              {...this.props}
              isMobile={this.props.isMobile}
              placeholder={translate("search.placeholder")}
              geolocationButtonText={translate("search.geolocation")}
              shouldShowDirectionsButton={false}
              shouldShowGeolocationButton={this.props.isGeolocationAvailable}
              onGeolocationButtonClick={() => this.props.onGeolocationSelect()}
              translate={translate}
            />
          </div>
          <SettingsButton />
        </div>
        {this.renderBackButton()}
      </Pane>
    )
  }
}

export default View
